import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toaster, Notification } from 'rsuite';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const NOTIFICATION_DURATION = 4000;

const NotFoundRedirect = ({ fallbackPath }) => {
    const history = useHistory();
    const { t } = useTranslation();

    useEffect(() => {
        toaster.push(
            <Notification type="error" header={t('errors.title')} closable>
                {t('errors.pageNotFound')}
            </Notification>,
            { placement: 'topCenter', duration: NOTIFICATION_DURATION }
        );
        history.replace(fallbackPath);
    }, [history, fallbackPath, t]);

    return null;
};

NotFoundRedirect.propTypes = {
    fallbackPath: PropTypes.string.isRequired
};

export default NotFoundRedirect;
